import { Updater } from 'widgets-for-react'

export const fieldUpdater = <State>() => <Key extends keyof State>(key: Key) => (updater: Updater<State[Key]>) => (
  state: State
): State => ({ ...state, [key]: updater(state[key]) })

export const fieldReplacer = <State>() => <Key extends keyof State>(key: Key) => (newValue: State[Key]) =>
  fieldUpdater<State>()(key)(() => newValue)
